/* React */
import React from "react";

/* Ionic */
import { IonIcon } from "@ionic/react";
import {
  options,
  chevronUp,
  chevronDown,
  downloadOutline,
} from "ionicons/icons";

/* Utils */
import { capitalizeCamelCaseFirstLetter } from "src/utils/helper/string-transformation";

/* Components */
import PrimaryFabButton from "src/components/shared/buttons/primary-fab-button/PrimaryFabButton";

/* Stylesheet */
import styles from "./TableOptions.module.scss";

/* Interfaces */
interface TableOptionsProps {
  label?: string;
  showTable: boolean;
  toggleShowTable: () => void;
  onDownload?: () => void;
  isDownloading?: boolean;
}

const TableOptions: React.FC<TableOptionsProps> = ({
  label,
  showTable,
  toggleShowTable,
  onDownload,
  isDownloading = false,
}) => {
  return (
    <div className={styles.table_options}>
      <div className={styles.label}>
        <IonIcon className={styles.icon} icon={options} />
        {capitalizeCamelCaseFirstLetter(label ?? "")}
      </div>
      <div className={styles.actions}>
        {onDownload !== undefined ? (
          <button
            type="button"
            className={`${styles.download_button} ${isDownloading ? styles.download_button_loading : ""}`}
            onClick={onDownload}
            disabled={isDownloading}
            aria-label="Download table as CSV"
            title="Download as CSV"
          >
            <IonIcon icon={downloadOutline} />
          </button>
        ) : undefined}
        <PrimaryFabButton
          scssProps={{
            margin: "0px 0px 0px 0px",
            background: "transparent",
            color: "var(--ion-color-text-primary)",
          }}
          className={"small"}
          ariaLabel={"Table Options"}
          icon={showTable ? chevronUp : chevronDown}
          onClick={toggleShowTable}
        />
      </div>
    </div>
  );
};

export default TableOptions;
